"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchSingleApplicationFeatures = exports.fetchApplicationFeatures = void 0;
const fetchApplicationFeatures = (apps) => __awaiter(void 0, void 0, void 0, function* () {
    const promises = apps.map(a => (0, exports.fetchSingleApplicationFeatures)(a));
    const features = yield Promise.all(promises);
    return features.reduce((acc, feature) => {
        acc[feature.name] = feature;
        return acc;
    }, {});
});
exports.fetchApplicationFeatures = fetchApplicationFeatures;
const fetchSingleApplicationFeatures = (app) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `https://feature-flags.decentraland.org/${app}.json`;
    const response = yield fetch(url, { credentials: 'include', mode: 'cors' });
    const json = yield response.json();
    return {
        name: app,
        flags: json.flags,
        variants: json.variants
    };
});
exports.fetchSingleApplicationFeatures = fetchSingleApplicationFeatures;
//# sourceMappingURL=utils.js.map